import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

import addHooks from './hooks'

Vue.use(Router)

const router = addHooks(new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
}))

export default router
